import { Button } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import React from 'react'
import injectSheet from 'react-jss'

const styles = {
	bottomButton: {
		margin: '0 !important',
		'border-radius': '0 !important',
		width: '100%',
		'font-size': '2em !important',
		height: '15vh'
	}
}
function BottomButton({ icon, classes, content, onClick, loading }) {
	return (
		<Button
			icon={icon}
			loading={loading}
			disabled={loading}
			labelPosition="right"
			content={content}
			size="tiny"
			primary
			onClick={onClick}
			className={classes.bottomButton}
		/>
	)
}
BottomButton.propTypes = {
	classes: PropTypes.object.isRequired,
	icon: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	loading: PropTypes.bool
}
BottomButton.defaultProps = {
	icon: 'arrow right'
}

export default injectSheet(styles)(BottomButton)



// WEBPACK FOOTER //
// ./src/components/BottomButton.js